import { render, staticRenderFns } from "./BaiDu.vue?vue&type=template&id=eb544e80&scoped=true"
import script from "./BaiDu.vue?vue&type=script&lang=js"
export * from "./BaiDu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb544e80",
  null
  
)

export default component.exports